<template>
  <!-- 有文字提示弹窗 -->
  <ll-tooltip
    v-if="showTip"
    :tip="tipText"
    :is-white-bg="isWhiteBg"
    :arrow="arrow"
    :class="[bem.e('tooltip'), tooltipClass]"
  >
    <ll-button
      ref="btnRef"
      type="text"
      :disabled="disabled"
      :class="`${btnClass}`"
      :style="btnStyle"
      :label="label"
      :icon-space="8"
      @click="onClick"
      @mouseenter="handleHover(true)"
      @mouseleave="handleHover(false)"
    >
      <template #icon>
        <ll-icon :style="iconStyle" :icon-name="iconName" :size="iconSize" />
      </template>
    </ll-button>
  </ll-tooltip>

  <!-- 没有文字提示弹窗 -->
  <ll-button
    v-else
    ref="btnRef"
    type="text"
    :disabled="disabled"
    :class="`${btnClass}`"
    :style="btnStyle"
    :label="label"
    :icon-space="8"
    @click="onClick"
    @mouseenter="handleHover(true)"
    @mouseleave="handleHover(false)"
  >
    <template #icon>
      <ll-icon :style="iconStyle" :icon-name="iconName" :size="iconSize" />
    </template>
  </ll-button>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { iconBaseProProps } from './icon-base-pro'

defineOptions({ name: 'LlIconBasePro' })

const bem = createNamespace('icon-base-pro')

const props = defineProps(iconBaseProProps)
const emits = defineEmits(['click'])

const btnRef = ref()
const isHover = ref(false)

const btnClass = computed(() => {
  const isDefault = props.iconType === 'default' || !props.iconType

  // 1.类型的class
  const typeClass = isDefault ? bem.is('default') : bem.is('primary')

  // 2.禁用的class
  const disabledClass = props.disabled
    ? isDefault
      ? bem.is('default-disable')
      : bem.is('primary-disable')
    : ''

  // 3. label
  const labelClass = props.label ? bem.is('label') : ''

  // 4.尺寸的class
  const getSizeClass = () => {
    switch (props.size) {
      case 'large':
        return 'large'
      case 'middle':
        return 'middle'
      case 'small':
        return 'small'
      default:
        'custom'
    }
  }
  const sizeClass = bem.is(getSizeClass())

  return `${
    props.class
  } ${bem.b()} ${typeClass} ${disabledClass} ${sizeClass} ${labelClass}`
})

const btnStyle = computed(() => {
  return {
    'background-color': isHover.value ? props.hoverBgColor : props.bgColor,
    ...(typeof props.size === 'number'
      ? { width: props.size + 'px', height: props.size + 'px' }
      : {}),
  }
})

const iconStyle = computed(() => ({
  transform: `scale(${isHover.value ? props.hoverScale : 1})`,
}))

const onClick = () => {
  emits('click')
  btnRef.value?.blur()
}

const handleHover = (bool: boolean) => {
  isHover.value = bool
}
</script>
